import React from "react";
import bg1 from "./img/banner-bg.png";
import bg2 from "./img/banner-bg2.png";
import LoadingSpinner from "../components/LoadingSpinner";

const Banner = (props) => {
  const [mobileScreen, setMobileScreen] = React.useState(true);
  const [isMediaPreviewOpen, setIsMediaPreviewOpen] = React.useState(false);
  const shouldShowTitleOverlay = !props.hideTitleOverlay && !props.event?.noTitle;
  const bannerMediaUrl = props.event?.mediaUrl || props.event?.imageUrl;
  const isBannerVideo = props.event?.mediaIsVideo;

  const handleMobile = () => {
    const width = window.innerWidth;
    if (width < 767) {
      setMobileScreen(true);
    } else {
      setMobileScreen(false);
    }
  };

  React.useEffect(() => {
    handleMobile();
    window.addEventListener("resize", handleMobile);
    return () => window.removeEventListener("resize", handleMobile);
  }, []);

  React.useEffect(() => {
    if (!isMediaPreviewOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsMediaPreviewOpen(false);
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isMediaPreviewOpen]);

  return (
    <section className={props.event?.noTitle ? "clear-banner-section" : "banner-section"}>
      <div className="banner-media-layer">
        {isBannerVideo ? (
          <>
            <video
              src={bannerMediaUrl}
              autoPlay
              playsInline
              loop
              muted
              className="banner-img banner-img-backdrop"
            />
            <video
              src={bannerMediaUrl}
              autoPlay
              playsInline
              loop
              muted
              className="banner-img banner-img-foreground"
            />
          </>
        ) : (
          <>
            <img src={bannerMediaUrl} className="banner-img banner-img-backdrop" alt="" />
            <img src={bannerMediaUrl} className="banner-img banner-img-foreground" alt="" />
          </>
        )}
      </div>
      {bannerMediaUrl ? (
        <button
          type="button"
          className="banner-media-open-button"
          onClick={() => setIsMediaPreviewOpen(true)}
          aria-label="Ouvrir le media de la banniere en grand"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className="banner-media-open-icon"
            fill="none"
          >
            <path
              d="M8 3H3v5M16 3h5v5M21 16v5h-5M3 16v5h5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      ) : null}
      <div className="container">
        <div className="banner-content">
          {shouldShowTitleOverlay && props.event?.name ? (
            <>
              <h1 className={props.event.name.length > 25 ? "long-title" : "title"}>
                {props.event.name}
              </h1>
              {props?.event?.description && props?.takeaway && (
                <p className="description">{props.event.description}</p>
              )}
            </>
          ) : (
            shouldShowTitleOverlay && <LoadingSpinner height="30%" width="30%" />
          )}
        </div>
      </div>
      {isMediaPreviewOpen ? (
        <div
          className="banner-media-preview"
          role="dialog"
          aria-modal="true"
          aria-label="Media de la banniere"
          onClick={() => setIsMediaPreviewOpen(false)}
        >
          <button
            type="button"
            className="banner-media-preview-close"
            onClick={() => setIsMediaPreviewOpen(false)}
            aria-label="Fermer"
          >
            Fermer
          </button>
          <div
            className="banner-media-preview-content"
            onClick={(event) => event.stopPropagation()}
          >
            {isBannerVideo ? (
              <video
                src={bannerMediaUrl}
                className="banner-media-preview-item"
                controls
                autoPlay
                playsInline
              />
            ) : (
              <img
                src={bannerMediaUrl}
                className="banner-media-preview-item"
                alt={props.event?.name || "Banniere"}
              />
            )}
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default Banner;
